import { useCities as s } from "../useCities.js";
const l = () => {
  const [, t] = s();
  return t ? [...(t || []).filter((e) => e && e.trim() !== "")].sort((e, i) => e.localeCompare(i)).map((e) => ({
    value: e,
    name: e,
    label: e
  })) : [];
};
export {
  l as useCityOptions
};
